module.exports = __webpack_public_path__ + "img/app_store.0b219b35.png";